









































import {Component, Prop, Vue} from "vue-property-decorator";
import AnalyticsBlock from "./AnalyticsBlock.vue";
import AnalyticsBars from "./AnalyticsBars.vue";
import Spinner from "@service/components/Spinner.vue";
import {formatDate} from "@common/dateTimeHelper";
import {DateTime} from "luxon";
import {
    AnalyticsVisit,
    AnalyticsVisitor,
    PartnerAnalyticsDataInterface
} from "@api/repositories/interfaces/PartnerAnalyticsDataInterface";
import AnalyticsUsers from "@share/catalog/components/AnalyticsUsers.vue";
import {BarItemInterface} from "../interfaces/AnalyticsInterfaces";
import AnalyticsIndicator from "@share/catalog/components/AnalyticsIndicator.vue";
import {AnalyticsIndicator as AnalyticsIndicatorInterface} from '@share/catalog/interfaces/AnalyticsIndicator';
import {ArrayHelpers} from "@common/ArrayHelpers";

@Component({
    name: "CatalogAnalytics",
    components: {
        AnalyticsIndicator, AnalyticsUsers, AnalyticsBlock, AnalyticsBars, Spinner
    }
})
export default class Analytics extends Vue {
    @Prop({required: true}) data: PartnerAnalyticsDataInterface | undefined;

    isLoading = false;
    test = 'VisitorsIcon'

    get language() {
        return this.$store.state.session.language ?? 'en';
    }

    get dateLabel() {
        return `${this.from} - ${this.to}`;
    }

    get fromDate() {
        return DateTime.fromISO(this.data?.period.from as string);
    }

    get toDate() {
        return DateTime.fromISO(this.data?.period.to as string);
    }

    get from(): string {
        return formatDate(this.fromDate, this.language, this.fromDate.year == this.toDate.year);
    }

    get to(): string {
        return formatDate(this.toDate, this.language);
    }

    get periodIndicators(): AnalyticsIndicatorInterface[] {
        return [
            {
                icon: 'VisitorsIcon',
                label: 'visitors',
                value: this.visitors.filter((item: AnalyticsVisitor) => !item.isToday).length.toString()
            },
            {
                icon: 'ViewsIcon',
                label: 'views-label',
                value: ArrayHelpers.sumBy(this.data?.exhibition?.visits.filter((item: AnalyticsVisit) => !item.isToday) ?? [], 'visits').toString()
            }
        ]
    }

    get todayIndicators(): AnalyticsIndicatorInterface[] {
        return [
            {
                label: 'visitors',
                value: this.visitors.filter((item: AnalyticsVisitor) => item.isToday).length.toString()
            },
            {
                label: 'views',
                value: ArrayHelpers.sumBy(this.data?.exhibition?.visits.filter((item: AnalyticsVisit) => item.isToday) ?? [], 'visits').toString()
            }
        ]
    }

    get visitors() {
        return this.data?.exhibition?.visitors ? Object.values(this.data?.exhibition?.visitors) : [];
    }

    get visits(): BarItemInterface[] {
        if (this.data?.exhibition?.visits) {
            return Object.values(this.data?.exhibition?.visits).map(item => {
                return {
                    value: item.visits,
                    date: DateTime.fromISO(item.date)
                } as BarItemInterface;
            })
        }
        return [];
    }

    get timeOnScreen(): BarItemInterface[] {
        if (this.data?.exhibition?.visits) {
            return Object.values(this.data?.exhibition?.visits).map(item => {
                return {
                    value: item.duration,
                    date: DateTime.fromISO(item.date)
                } as BarItemInterface;
            })
        }

        return [];
    }
}
